.root {
  width: auto;
  height: 100%;
  position: relative;
  outline: none;
}
